import { getLandingPageByPath } from "./registry";

/** Set by the inline script at the top of index.html on registered landing paths. */
export interface EarlyLandingContent {
  slug: string;
  status: "pending" | "ready";
  value: unknown;
  promise: Promise<unknown>;
}
declare global {
  interface Window {
    __landingContent?: EarlyLandingContent;
  }
}

/** Promise main.tsx waits for before the first render, or null to render now. */
export function landingBootGate(win: Window = window): Promise<unknown> | null {
  const page = getLandingPageByPath(win.location.pathname);
  const early = win.__landingContent;
  if (!page || !early || early.slug !== page.slug || !early.promise) return null;
  return Promise.resolve(early.promise).catch(() => null);
}
